import { useState, useEffect } from 'react'
import { useLocalAudioInputActivity, useToggleLocalMute } from 'amazon-chime-sdk-component-library-react'

/**
 * Hook pour monitorer le niveau d'activité du microphone
 * @returns Le niveau audio actuel (0-1), ou 0 si le micro est coupé
 */
export function useAudioMonitor(): number {
  const [rawAudioLevel, setRawAudioLevel] = useState(0)
  const [audioLevel, setAudioLevel] = useState(0)
  const { muted } = useToggleLocalMute()

  // Monitorer le niveau audio brut
  useLocalAudioInputActivity(setRawAudioLevel)

  // Mettre à jour le niveau affiché en fonction de l'état muted
  useEffect(() => {
    if (muted) {
      setAudioLevel(0)
    } else {
      setAudioLevel(rawAudioLevel)
    }
  }, [muted, rawAudioLevel])

  return audioLevel
}
